import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home             from '../pages/Home';
import About            from '../pages/About';
import JobList          from '../pages/JobList';
import JobDetail        from '../pages/JobDetail';
import Category         from '../pages/Category';
import Testimonial      from '../pages/Testimonial';
import Contact          from '../pages/Contact';
import Auth             from '../pages/Auth';
import OAuthCallback    from '../pages/OAuthCallback';
import MyProfile        from '../pages/MyProfile';
import MyApplications   from '../pages/MyApplications';
import SavedJobs        from '../pages/SavedJobs';
import PostJob          from '../pages/PostJob';
import Pricing          from '../pages/Pricing';
import PrivacyPolicy    from '../pages/PrivacyPolicy';
import RefundPolicy     from '../pages/RefundPolicy';
import TermsOfService   from '../pages/TermsOfService';
import JobAlerts        from '../pages/JobAlerts';
import CareerAdvice     from '../pages/CareerAdvice';
import BrowseCandidates from '../pages/BrowseCandidates';
import HiringSolutions  from '../pages/HiringSolutions';
import NotFound         from '../pages/NotFound';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/"                   element={<Home />} />
      <Route path="/about"              element={<About />} />
      <Route path="/job-list"           element={<JobList />} />
      <Route path="/job-detail/:id"     element={<JobDetail />} />
      <Route path="/category"           element={<Category />} />
      <Route path="/testimonial"        element={<Testimonial />} />
      <Route path="/contact"            element={<Contact />} />
      <Route path="/login"              element={<Auth />} />
      <Route path="/oauth-callback"     element={<OAuthCallback />} />
      <Route path="/profile"            element={<MyProfile />} />
      <Route path="/my-applications"    element={<MyApplications />} />
      <Route path="/saved-jobs"         element={<SavedJobs />} />
      <Route path="/post-job"           element={<PostJob />} />
      <Route path="/pricing"            element={<Pricing />} />
      <Route path="/privacy-policy"     element={<PrivacyPolicy />} />
      <Route path="/refund-policy"      element={<RefundPolicy />} />
      <Route path="/terms-of-service"   element={<TermsOfService />} />
      <Route path="/job-alerts"         element={<JobAlerts />} />
      <Route path="/career-advice"      element={<CareerAdvice />} />
      <Route path="/browse-candidates"  element={<BrowseCandidates />} />
      <Route path="/hiring-solutions"   element={<HiringSolutions />} />
      <Route path="*"                   element={<NotFound />} />
    </Routes>
  );
}
